import {hasPermission, isDevEnv, isLgs, isParent, isStudent} from 'common/HelperFunctions'

import {isModuleBetaEnabled} from '.'

/** localStorage key of the student/parent fee page beta toggle. */
export const FEE_BETA_KEY = 'fee-beta'

/** Routes on which the fee beta toggle is offered (legacy page + native page). */
export const FEE_BETA_ROUTES = ['/finance/finance/view', '/fee/vouchers']

/**
 * Whether the native React fee page replaces the legacy PHP iframe for the
 * logged-in student/parent. LGS keeps its own fee integration (`/fee` and
 * `/site/lgsFee`), every other tenant gets the native page on dev/staging
 * and behind the `fee-beta` toggle on prod.
 */
export const isNewFeePageEnabled = () => {
  if (isLgs()) return false
  return isDevEnv() || isModuleBetaEnabled(FEE_BETA_KEY)
}

/** Path of the student/parent fee section for the current tenant/toggle state. */
export const getStudentFeePath = () =>
  isNewFeePageEnabled() ? '/fee/vouchers' : '/finance/finance/view/0'

/**
 * Whether to offer the fee beta toggle on the given route: only to
 * students/parents with the fee section, on non-LGS tenants, on prod (dev
 * and staging always show the native page so the toggle would be a no-op).
 */
export const isFeeBetaToggleVisible = (pathname: string) => {
  if (isDevEnv() || isLgs()) return false
  if (!(isStudent() || isParent())) return false
  if (!hasPermission('fee_manager')) return false
  return FEE_BETA_ROUTES.some((route) => pathname.startsWith(route))
}
